import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import bookingProtectionGlossaryMessages from 'i18n/bookingProtectionGlossaryMessages'
import productLabels from 'i18n/productLabels'

function useItemTypeLabels(): Record<string, string> {
  const intl = useIntl()
  return useMemo(() => ({
    accommodation: intl.formatMessage(productLabels.accommodation),
    tour: intl.formatMessage(productLabels.tour),
    tour_v2: intl.formatMessage(productLabels.tour),
    tour_optional_experience: intl.formatMessage({ id: 'L94BDPxR7yg-WwZJ4Vhj', defaultMessage: 'Optional experiences', description: 'Human-readable label for the tour optional experiences item type' }),
    cruise: intl.formatMessage(productLabels.cruise),
    experience: intl.formatMessage(productLabels.experience),
    flight: intl.formatMessage(productLabels.flight),
    insurance: intl.formatMessage({ id: 'ToZ5tar53i-jENv_mPvP', defaultMessage: 'Insurance', description: 'Human-readable label for the insurance item type for computed display labels' }),
    subscription: intl.formatMessage({ id: 'srCMMsouxtlXlQS1QfFi', defaultMessage: 'LuxPlus+ Membership', description: 'Human-readable label for the LuxPlus+ membership item type' }),
    booking_protection: intl.formatMessage(bookingProtectionGlossaryMessages.cancellationProtection),
    car_hire: intl.formatMessage(productLabels.carHire),
    gift_card: intl.formatMessage({ id: '8qYevJgtE2eTAldqGt7g', defaultMessage: 'Gift Card', description: 'Human-readable label for the gift card item type for computed display labels' }),
    order: intl.formatMessage({ id: 'SVHSsgPzcNxF26-2mt1W', defaultMessage: 'Order', description: 'Human-readable label for the order item type for computed display labels' }),
    hotel: intl.formatMessage(productLabels.hotel),
    bedbankHotel: intl.formatMessage(productLabels.hotel),
  }), [intl])
}

export default useItemTypeLabels
